<template lang="pug">
  .wrapper
    .container
      lei-popover.disabled-tooltip(v-if="isChallengeLEICodeDisabled"
        :text="leiCodeTabTooltip"
        :style="disabledTooltipPositionStyles")
        .disabled-tooltip-trigger
      el-tabs.lei-tabs(
        :value="activeTab"
        type="card"
        :before-leave="tabSwitch")
        el-tab-pane(label="Update Reference Data" key="reference_data"  name="reference_data")
          record-info
          challenge-control-section(:sticky="true")
        el-tab-pane(label="Update Relationship Data" key="relationship_data" name="relationship_data")
          challenge-parent(type="directParent")
          challenge-parent(type="ultimateParent")
          challenge-parent(type="fundManager")
          challenge-parent(type="umbrellaFund")
          challenge-parent(type="masterFund")
          challenge-parent(type="headOffice")
          challenge-control-section(:sticky="true")
        el-tab-pane(label="Entity Events" key="events_data" name="events_data")
          record-modifications-info
          challenge-control-section
        el-tab-pane(label="Challenge LEI Code" key="lei_code" name="lei_code" :disabled="isChallengeLEICodeDisabled")
          challenge-lei-code(:lvl1DataCanBeSaved="lvl1DataCanBeSaved")
          challenge-control-section
        el-tab-pane(label="Challenge vLEI Credential" key="vlei_credential" name="vlei_credential")
          credential-notice
</template>
<script>
import { mapMutations, mapGetters, mapState, mapActions, } from 'vuex'
import { TOGGLE_DISPLAY_SECTION, } from '@/store/modules/record/mutations-types'
import Challenge from '@/mixins/challenge'
import RecordInfo from '@/components/record-details/RecordInfo'
import ChallengeParent from '@/components/challenge-components/ChallengeParent'
import ChallengeLeiCode from '@/components/challenge-components/ChallengeLeiCode'
import { TOGGLE_AUTH_MODAL, } from '@/store/modules/auth/mutations-types'
import { CLEAR_CHALLENGE, } from '@/store/modules/record/modules/challenge/mutations-types'
import recordTooltips from '@/constants/tooltips/record'
import LeiPopover from '@/components/lei-components/LeiPopover'
import { EventBus, } from '@/event-bus'
import RecordModificationsInfo from '@/components/record-details/modifications/RecordModificationsInfo'
import ChallengeControlSection from '@/components/challenge-components/ChallengeControlSection'
import CredentialNotice from '@/components/record-details/credentials/CredentialNotice'


export default {
  components: {
    LeiPopover,
    ChallengeLeiCode,
    ChallengeParent,
    RecordInfo,
    RecordModificationsInfo,
    ChallengeControlSection,
    CredentialNotice,
  },
  mixins: [ Challenge, ],
  data () {
    return {
      activeTab: 'reference_data',
      disabledTooltipTrigger: {
        x: -100,
        y: 0,
        h: 0,
        w: 0,
      },
    }
  },
  computed: {
    isChallengeLEICodeDisabled () {
      if (!this.record || !this.record.registration) {
        return false
      }
      let { status, } = this.record.registration
      return status === 'DUPLICATE' || status === 'ANNULLED'
    },
    lvl1DataCanBeSaved () {
      return this.$route.params.tab === 'lei_code'
    },
    disabledTooltipPositionStyles () {
      return `top:${this.disabledTooltipTrigger.y}px;
      left:${this.disabledTooltipTrigger.x}px;
      width:${this.disabledTooltipTrigger.w}px;
      height:${this.disabledTooltipTrigger.h}px;
      `
    },
    leiCodeTabTooltip () {
      return recordTooltips.leiCodeTab
    },

    ...mapGetters('auth', [ 'authUser', ]),
    ...mapState('search', [ 'filters', ]),
    ...mapState('record', [ 'record', ]),
  },
  created () {
    if (!this.filters) this.getFilters()
    if (!this.authUser) this.toggleAuthModal(true)
    this.toggleDisplay({
      property: 'showEmptyFields',
      value: true,
    })
    this.setTab()
  },
  mounted () {
    this.initDisabledTooltipPosition()
  },
  methods: {
    /**
     * Because el-tab-pane cant be wrapped to lei-popover, transparent div is created and placed over inactive tab.
     */
    initDisabledTooltipPosition () {
      let findingXOffset = () => {
        setTimeout(() => {
          let tabLeiCode = document.getElementById('tab-lei_code')
          if (!tabLeiCode) {
            findingXOffset()
          } else {
            let rect = tabLeiCode.getBoundingClientRect()
            this.disabledTooltipTrigger.x = rect.x
            this.disabledTooltipTrigger.y = rect.y + window.scrollY
            this.disabledTooltipTrigger.w = rect.width
            this.disabledTooltipTrigger.h = rect.height
          }
        }, 1000)
      }
      findingXOffset()
    },
    setTab () {
      this.activeTab = this.$route.params.tab || 'reference_data'
    },
    routerTabChange (tab) {
      this.$router.push({
        name: 'Challenge',
        params: { tab, },
      })
    },
    tabSwitch (activeTab, oldTab) {
      if (oldTab === 'lei_code' || activeTab === 'lei_code') {
        const message = 'Reference, Parent and Entity Events Data cannot be challenged together with the LEI Code. All progress on this page will be lost.'
        return this.$confirm(message, {
          type: 'warning',
        }).then(() => {
          EventBus.$emit('challengeTabSwitchWithDataLost')
          this.clearChallenge()
          this.$message({
            type: 'warning',
            message: 'Changes were not saved',
          })
          this.routerTabChange(activeTab)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Challenge in current tab continues',
          })
          return Promise.reject()
        })
      } else {
        this.routerTabChange(activeTab)
      }
    },

    ...mapMutations('record', {
      toggleDisplay: TOGGLE_DISPLAY_SECTION,
    }),
    ...mapMutations('record/challenge', {
      clearChallenge: CLEAR_CHALLENGE,
    }),
    ...mapMutations('auth', {
      toggleAuthModal: TOGGLE_AUTH_MODAL,
    }),
    ...mapActions('search', [ 'getFilters', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .disabled-tooltip
    position absolute
    z-index 3
  .disabled-tooltip-trigger
    width 100%
    height 100%
    cursor not-allowed
</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeMode.vue